export default (error: string | undefined | null) => {
  return (error || '').replace(/GraphQL error: /, '')
}
